/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import useGoogleMapMarker from './useGoogleMapMarker';
import MarkerRedIcon from '../../../assets/mapMarkers/MarkerRed.png';
import MarkerGreenIcon from '../../../assets/mapMarkers/MarkerGreen.png';

const activeIcon = MarkerGreenIcon; //further improvements needed
const inactiveIcon = MarkerRedIcon; //further improvements needed

export default function Marker({
  position,
  type,
  maps,
  map,
  cluster,
  events,
  active = false,
  title,
  label,
}) {
  const marker = useGoogleMapMarker({
    position,
    type,
    maps,
    map,
    events,
    title,
    active, //further improvements needed
    label,
  });

  useEffect(() => {
    marker && cluster.addMarker(marker);
  }, [marker, cluster]);

  useEffect(() => {
    marker &&
      (active ? marker.setIcon(activeIcon) : marker.setIcon(inactiveIcon));
  }, [active]);

  return null;
}
